<template>
  <v-dialog
      v-model="value"
      max-width="500px"
      @input="(v) => v || closeAddPlantInfoDialog()"
  >
    <v-card>
      <v-card-title>発電所情報入力</v-card-title>
      <v-card-text>
        <v-form
            ref="addPlantInfo"
            v-model="addPlantInfoValid"
            @submit.prevent="submitPrevent"
        >
          <v-text-field
              hide-details="auto"
              required
              outlined
              dense
              clearable
              label="経産省ID"
              :rules="[ministryIdDuplicateCheck]"
              v-model.trim="ministryIdAdd"
              @change="resetDuplicateCheck('ministryId')"
          ></v-text-field>
          <v-text-field
              hide-details="auto"
              required
              outlined
              dense
              clearable
              label="発電所名*"
              :rules="[(v) => (!!v && !!v.trim()) || '発電所名を記入してください。', nameDuplicateCheck]"
              v-model.trim="nameAdd"
              @change="resetDuplicateCheck('name')"
          ></v-text-field>
          <v-text-field
              hide-details="auto"
              required
              outlined
              dense
              clearable
              label="住所"
              :rules="[addressDuplicateCheck]"
              v-model.trim="addressAdd"
              @change="resetDuplicateCheck('address')"
          ></v-text-field>
          <v-text-field
              hide-details="auto"
              required
              outlined
              dense
              clearable
              label="DC"
              :rules="[numberRule]"
              v-model.number="dc"
              type="number"
              step="any"
              min="0"
              suffix="kW"
          ></v-text-field>
          <v-text-field
              hide-details="auto"
              required
              outlined
              dense
              clearable
              label="AC"
              :rules="[numberRule]"
              v-model.number="ac"
              type="number"
              step="any"
              min="0"
              suffix="kW"
          ></v-text-field>
          <v-autocomplete
              hide-details="auto"
              label="支店*"
              v-model="branch"
              dense
              :items="branches"
              outlined
              :rules="[(v) => (!!v) || '支店を記入してください。']"
              no-data-text="該当データがありません。"
              :item-value="item => item.id"
              :item-text="item => item.name"
          ></v-autocomplete>
          <v-autocomplete
              hide-details="auto"
              v-model="seller"
              :items="sellers"
              dense
              label="営業者"
              outlined
              no-data-text="該当データがありません。"
              :item-value="item => item.email"
              :item-text="item => item.name"
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            @click="closeAddPlantInfoDialog"
        >
          キャンセル
        </v-btn>
        <v-btn
            color="primary"
            @click="addPlantInfo"
        >
          作成
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {store} from "@/store";

export default {
  name: "AddMainPlantDialog",
  props: ['afterAddName', 'plantName', 'value'],
  data: () => ({
    addPlantDialog: false,
    nameAdd: '',
    addPlantInfoValid: true,
    nameDuplicateCheck: true,
    branch: null,
    branches: [],
    seller: null,
    sellers: [],
    ministryIdDuplicateCheck: true,
    ministryIdAdd: '',
    addressDuplicateCheck: true,
    addressAdd: '',
    ac: 0,
    dc: 0,
    numberRule: val => {
      if(val <= 0) return '０より数字を記入してください。'
      return true
    }
  }),
  methods: {
    addPlantInfo() {
      if (this.$refs.addPlantInfo.validate()) {
        // const name = this.nameAdd;
        const plant = {ministryId: this.ministryIdAdd, address: this.addressAdd};
        // const ministryId = this.ministryIdAdd;
        // const address = this.addressAdd;
        console.log({'plant': plant, 'name': this.nameAdd, 'dc': this.dc, 'ac': this.ac, 'branch': this.branch, 'seller': this.seller})
        this.axios
            .post('api/main-plant/store', {'plant': plant, 'name': this.nameAdd, 'dc': this.dc, 'ac': this.ac, 'branch': this.branch, 'seller': this.seller})
            .then(() => {
              store.showSuccessDialog('発電所追加が完了しました');
              this.$emit('updatePlantName', name);
              this.afterAddName();
              this.closeAllDialog();
            })
            .catch((error) => {
              if (error.response.status == 409) {
                this.nameDuplicateCheck = '発電所名は既に登録されました。別の発電所名にしてください。';
              } else {
                store.showErrorDialog('エラーが発生しました。再度試してください。');
                this.closeAllDialog();
              }
            });
      }
    },
    resetSearchDialog() {
      this.ministryIdAdd = '';
      this.nameAdd = '';
      this.addressAdd = '';
      this.ac = 0;
      this.dc = 0;
    },
    resetDuplicateCheck(type){
      switch (type){
        case 'name':{
          if (typeof this.nameDuplicateCheck == 'string'){
            this.nameDuplicateCheck = true;
          }
          break;
        }
        case 'ministryId': {
          if (typeof this.ministryIdDuplicateCheck == 'string'){
            this.ministryIdDuplicateCheck = true;
          }
          break;
        }
        case 'address': {
          if (typeof this.addressDuplicateCheck == 'string'){
            this.addressDuplicateCheck = true;
          }
          break;
        }
      }
    },
    resetAddPlantNameForm() {
      this.$refs.addPlantInfo.reset();
    },
    closeSearchDialog(){
      this.resetSearchDialog();
      this.$emit('closeDialog', false);
    },
    closeAllDialog() {
      this.closeAddPlantInfoDialog();
      this.closeSearchDialog();
    },
    closeAddPlantInfoDialog(){
      this.resetAddPlantNameForm();
      this.$emit('input');
    },
    submitPrevent(){
      // Do nothing
    },
    handle(){
      this.searchPlant();
    },
    getBranches(){
      this.axios.get('/api/branch/').then((response) => {
        this.branches = response.data;
      })
    },
    getSellers(){
      this.axios.get('/api/seller/').then((response) => {
        this.sellers = response.data;
      })
    }
  },
  created() {
    this.getBranches();
    this.getSellers();
  }
}
</script>

<style>
#searchPlantTable .v-data-table__wrapper{
  max-height: calc(100vh - 380px);
}
</style>
